/* Misk — pas d'impasse dans le choix or / pierre.
   La matrice est trouee : « or jaune + nacre » n'existe pas. Sans rien faire, le
   client se retrouve sans pierre selectionnee et sur « UNAVAILABLE ».
   Ici, si la combinaison demandee n'existe pas, on recharge la page sur la
   variante la plus proche — c'est le mecanisme natif du theme (?variant=ID),
   donc aucune manipulation du DOM et aucun conflit avec son rendu. */
(function () {
  'use strict';
  var vars = null, chargement = null;

  function handle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function charge() {
    if (vars) return Promise.resolve(vars);
    if (chargement) return chargement;
    var h = handle();
    if (!h) return Promise.resolve(null);
    chargement = fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { vars = (p && p.variants) || null; return vars; })
      .catch(function () { return null; });
    return chargement;
  }
  function nom(input) {
    var lab = input.id && document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
    if (!lab) lab = input.closest('label') || input.nextElementSibling;
    if (!lab) return null;
    var sr = lab.querySelector('.sr-only');
    return (sr ? sr.textContent : lab.textContent).trim();
  }
  function selection(picker) {
    var sel = {};
    picker.querySelectorAll('input[type="radio"][data-option-position]:checked').forEach(function (r) {
      sel[parseInt(r.dataset.optionPosition, 10)] = nom(r);
    });
    return sel;
  }

  document.addEventListener('click', function (e) {
    try {
      var lab = e.target.closest('label'); if (!lab) return;
      var picker = lab.closest('variant-picker'); if (!picker) return;
      var input = lab.htmlFor ? document.getElementById(lab.htmlFor) : lab.querySelector('input');
      if (!input || input.type !== 'radio' || !input.dataset.optionPosition) return;

      charge().then(function (V) {
        if (!V || !V.length) return;
        var pos = parseInt(input.dataset.optionPosition, 10);
        var vise = nom(input); if (!vise) return;
        var sel = selection(picker); sel[pos] = vise;
        var positions = Object.keys(sel).map(Number);

        var existe = V.some(function (v) {
          return positions.every(function (p) { return v.options[p - 1] === sel[p]; });
        });
        if (existe) return;                       // le theme fait son travail

        // on respecte le choix qui vient d'etre fait, on cede sur le reste,
        // en preferant une combinaison reellement disponible
        var cands = V.filter(function (v) { return v.options[pos - 1] === vise; });
        if (!cands.length) return;
        var cible = cands.filter(function (v) { return v.available; })[0] || cands[0];
        var u = new URL(location.href);
        u.searchParams.set('variant', cible.id);
        location.assign(u.toString());
      });
    } catch (err) { /* jamais bloquer la fiche produit */ }
  }, true);

  if (document.readyState !== 'loading') charge();
  else document.addEventListener('DOMContentLoaded', charge);
})();
